export const DEFAULT_DOMAIN = 'DOM_0020'
export const LOG_FORWARDER_URL = 'https://log-forwarder.product-page-layouts.vpsvc.com/'
export const SERVICE_NAME = 'fragment-bookends-v2'
export const TEAM_TAG = 'VPD-0010'
